<template>
  <v-text-field
  v-model="inputVal"
    type="text"
    label='Mochi ID'
    key="name"
    :rules="rules"
  ></v-text-field>
</template>

<script>
export default {
   props: ["value"],
    data: () => ({
    name: null,
     rules : [v => !!v || 'Mochi Id is required'],
   
  }),
   computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style>
</style>